import { NgModule } from 'ng-metadata/core';
import { AccountMenuComponent } from './account-menu/account-menu.component';
import { AppContainerComponent } from './app-container.component';
import { AppHeaderComponent } from './app-header/app-header.component';
import { NavigationComponent } from './navigation/navigation.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { AppContainerStateService } from './app-container-state.service';

/**
 * @ngdoc module
 * @name mw.components.appContainer
 * @description
 *
 * App Login
 */
@NgModule({
    imports: ['pascalprecht.translate', 'ngCookies'],
    declarations: [ AccountMenuComponent, AppContainerComponent, AppHeaderComponent, NavigationComponent, UserMenuComponent ],
    providers: [{ provide: 'mwAppContainerStateService', useClass: AppContainerStateService }]
})
export class AppContainerModule {}



// WEBPACK FOOTER //
// ./src/lib/components/app-container/app-container.module.ts